<div class="admin-page">
  <div class="page-header">
    <h1>{{ 'SIGN_ORDER.ADMIN.CONFIG_TITLE' | translate }}</h1>
  </div>

  <nz-tabset>
    <nz-tab [nzTitle]="'SIGN_ORDER.ADMIN.TAB_SETTINGS' | translate">
      <nz-spin [nzSpinning]="settingsLoading">
        <form nz-form nzLayout="vertical" [formGroup]="settingsForm" class="config-form">
          <nz-alert
            *ngIf="settingsError"
            nzType="error"
            [nzMessage]="settingsError"
            nzShowIcon
            class="form-alert"
          ></nz-alert>

          <nz-card>
            <nz-form-item>
              <nz-form-label>{{ 'SIGN_ORDER.ADMIN.ORDERING_ENABLED' | translate }}</nz-form-label>
              <nz-form-control>
                <nz-switch formControlName="orderingEnabled"></nz-switch>
              </nz-form-control>
            </nz-form-item>

            <nz-alert
              *ngIf="settingsForm.touched && settingsFormValidationKey()"
              nzType="warning"
              [nzMessage]="settingsFormValidationKey()! | translate"
              nzShowIcon
              class="form-alert"
            ></nz-alert>

            <nz-card [nzTitle]="'SIGN_ORDER.ADMIN.SHIPPING_TIERS' | translate" nzSize="small">
              <p class="form-help">{{ 'SIGN_ORDER.ADMIN.SHIPPING_TIER_HELP' | translate }}</p>

              <div formArrayName="shippingTiers">
                <nz-table [nzData]="shippingTiers.controls" [nzShowPagination]="false" nzSize="small" [nzScroll]="{ x: '720px' }">
                  <thead>
                    <tr>
                      <th>{{ 'SIGN_ORDER.ADMIN.TIER_MIN' | translate }}</th>
                      <th>{{ 'SIGN_ORDER.ADMIN.TIER_MAX' | translate }}</th>
                      <th>{{ 'SIGN_ORDER.ADMIN.SHIPPING_TIER_PRICE' | translate }}</th>
                      <th>{{ 'SIGN_ORDER.ADMIN.UNLIMITED' | translate }}</th>
                      <th>{{ 'SIGN_ORDER.ADMIN.ACTIONS' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let tier of shippingTiers.controls; index as i" [formGroupName]="i">
                      <td>
                        <nz-input-number formControlName="minQuantity" [nzMin]="1" [nzStep]="1" [nzPrecision]="0" nzSize="small"></nz-input-number>
                      </td>
                      <td>
                        <nz-input-number
                          formControlName="maxQuantity"
                          [nzMin]="1"
                          [nzStep]="1"
                          [nzPrecision]="0"
                          [nzDisabled]="tier.get('unlimited')?.value === true"
                          nzSize="small"
                        ></nz-input-number>
                      </td>
                      <td>
                        <nz-input-number formControlName="shippingNetCents" [nzMin]="0" [nzStep]="1" [nzPrecision]="0" nzSize="small"></nz-input-number>
                      </td>
                      <td>
                        <nz-switch formControlName="unlimited" (nzCheckedChange)="setTierUnlimited(tier, $event)"></nz-switch>
                      </td>
                      <td>
                        <button
                          nz-button
                          nzDanger
                          nzSize="small"
                          type="button"
                          [attr.aria-label]="'SIGN_ORDER.ADMIN.REMOVE_SHIPPING_TIER' | translate"
                          [nzTooltipTitle]="'SIGN_ORDER.ADMIN.REMOVE_SHIPPING_TIER' | translate"
                          nz-tooltip
                          (click)="removeShippingTier(i)"
                        >
                          <i nz-icon nzType="delete"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </nz-table>
              </div>

              <nz-alert
                *ngIf="shippingTiers.touched && shippingTierValidationKey()"
                nzType="error"
                [nzMessage]="shippingTierValidationKey()! | translate"
                nzShowIcon
                class="tier-validation"
              ></nz-alert>

              <button
                nz-button
                nzType="dashed"
                type="button"
                [disabled]="!canAddShippingTier()"
                (click)="addShippingTier()"
              >
                <i nz-icon nzType="plus"></i>
                {{ 'SIGN_ORDER.ADMIN.ADD_SHIPPING_TIER' | translate }}
              </button>
            </nz-card>

            <div class="form-row">
              <nz-form-item>
                <nz-form-label>{{ 'SIGN_ORDER.ADMIN.VAT_RATE' | translate }}</nz-form-label>
                <nz-form-control>
                  <nz-input-number formControlName="vatRateBasisPoints" [nzMin]="0" [nzMax]="10000" [nzStep]="1" [nzPrecision]="0"></nz-input-number>
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label>{{ 'SIGN_ORDER.ADMIN.PAYMENT_DUE_DAYS' | translate }}</nz-form-label>
                <nz-form-control>
                  <nz-input-number formControlName="paymentDueDays" [nzMin]="0" [nzMax]="365" [nzStep]="1" [nzPrecision]="0"></nz-input-number>
                </nz-form-control>
              </nz-form-item>
            </div>

            <nz-form-item>
              <nz-form-label>{{ 'SIGN_ORDER.ADMIN.PAYMENT_RECIPIENT' | translate }}</nz-form-label>
              <nz-form-control>
                <input nz-input formControlName="paymentRecipient" />
              </nz-form-control>
            </nz-form-item>

            <div class="form-row">
              <nz-form-item>
                <nz-form-label>{{ 'SIGN_ORDER.ADMIN.IBAN' | translate }}</nz-form-label>
                <nz-form-control>
                  <input nz-input formControlName="iban" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label>{{ 'SIGN_ORDER.ADMIN.BIC' | translate }}</nz-form-label>
                <nz-form-control>
                  <input nz-input formControlName="bic" />
                </nz-form-control>
              </nz-form-item>
            </div>

            <nz-form-item>
              <nz-form-label>{{ 'SIGN_ORDER.ADMIN.PAYMENT_INSTRUCTIONS_DE' | translate }}</nz-form-label>
              <nz-form-control>
                <textarea nz-input formControlName="paymentInstructionsDe" rows="4"></textarea>
              </nz-form-control>
            </nz-form-item>

            <nz-form-item>
              <nz-form-label>{{ 'SIGN_ORDER.ADMIN.PAYMENT_INSTRUCTIONS_EN' | translate }}</nz-form-label>
              <nz-form-control>
                <textarea nz-input formControlName="paymentInstructionsEn" rows="4"></textarea>
              </nz-form-control>
            </nz-form-item>

            <nz-form-item>
              <nz-form-label>{{ 'SIGN_ORDER.ADMIN.NOTIFICATION_RECIPIENTS' | translate }}</nz-form-label>
              <nz-form-control>
                <input nz-input formControlName="adminNotificationRecipients" [placeholder]="'SIGN_ORDER.ADMIN.NOTIFICATION_RECIPIENTS_HINT' | translate" />
              </nz-form-control>
            </nz-form-item>
          </nz-card>

          <div class="form-actions">
            <button nz-button nzType="primary" type="button" [nzLoading]="savingSettings" (click)="saveSettings()">
              {{ 'SIGN_ORDER.ADMIN.SAVE' | translate }}
            </button>
          </div>
        </form>
      </nz-spin>
    </nz-tab>

    <nz-tab [nzTitle]="'SIGN_ORDER.ADMIN.TAB_PRODUCT' | translate">
      <nz-spin [nzSpinning]="productLoading">
        <form nz-form nzLayout="vertical" [formGroup]="productForm" class="config-form">
          <nz-alert
            *ngIf="productError"
            nzType="error"
            [nzMessage]="productError"
            nzShowIcon
            class="form-alert"
          ></nz-alert>

          <nz-card>
            <nz-form-item>
              <nz-form-label>{{ 'SIGN_ORDER.ADMIN.PRODUCT_ACTIVE' | translate }}</nz-form-label>
              <nz-form-control>
                <nz-switch formControlName="active"></nz-switch>
              </nz-form-control>
            </nz-form-item>

            <nz-alert
              *ngIf="productForm.touched && productFormValidationKey()"
              nzType="warning"
              [nzMessage]="productFormValidationKey()! | translate"
              nzShowIcon
              class="form-alert"
            ></nz-alert>

            <div class="form-row">
              <nz-form-item>
                <nz-form-label>{{ 'SIGN_ORDER.ADMIN.PRODUCT_NAME_DE' | translate }}</nz-form-label>
                <nz-form-control>
                  <input nz-input formControlName="nameDe" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label>{{ 'SIGN_ORDER.ADMIN.PRODUCT_NAME_EN' | translate }}</nz-form-label>
                <nz-form-control>
                  <input nz-input formControlName="nameEn" />
                </nz-form-control>
              </nz-form-item>
            </div>

            <div class="form-row">
              <nz-form-item>
                <nz-form-label>{{ 'SIGN_ORDER.ADMIN.PRODUCT_DESC_DE' | translate }}</nz-form-label>
                <nz-form-control>
                  <textarea nz-input formControlName="descriptionDe" rows="3"></textarea>
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label>{{ 'SIGN_ORDER.ADMIN.PRODUCT_DESC_EN' | translate }}</nz-form-label>
                <nz-form-control>
                  <textarea nz-input formControlName="descriptionEn" rows="3"></textarea>
                </nz-form-control>
              </nz-form-item>
            </div>

            <div class="form-row">
              <nz-form-item>
                <nz-form-label>{{ 'SIGN_ORDER.ADMIN.ALLOW_WITHOUT_DRILLING' | translate }}</nz-form-label>
                <nz-form-control>
                  <nz-switch formControlName="allowWithoutDrilling"></nz-switch>
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label>{{ 'SIGN_ORDER.ADMIN.ALLOW_WITH_DRILLING' | translate }}</nz-form-label>
                <nz-form-control>
                  <nz-switch formControlName="allowWithDrilling"></nz-switch>
                </nz-form-control>
              </nz-form-item>
            </div>

            <nz-form-item>
              <nz-form-label>{{ 'SIGN_ORDER.ADMIN.UNIT_WEIGHT_GRAMS' | translate }}</nz-form-label>
              <nz-form-control>
                <div class="weight-input">
                  <nz-input-number formControlName="unitWeightGrams" [nzMin]="1" [nzStep]="1" [nzPrecision]="0"></nz-input-number>
                  <span>{{ 'SIGN_ORDER.ADMIN.GRAMS' | translate }}</span>
                </div>
                <p class="form-help">{{ 'SIGN_ORDER.ADMIN.UNIT_WEIGHT_HELP' | translate }}</p>
                <p class="validation-feedback" *ngIf="unitWeightValidationKey()">
                  {{ unitWeightValidationKey()! | translate }}
                </p>
              </nz-form-control>
            </nz-form-item>
          </nz-card>

          <nz-card [nzTitle]="'SIGN_ORDER.ADMIN.PRICING_TIERS' | translate">
            <p class="form-help">{{ 'SIGN_ORDER.ADMIN.UNLIMITED_HELP' | translate }}</p>

            <div formArrayName="pricingTiers">
              <nz-table [nzData]="pricingTiers.controls" [nzShowPagination]="false" nzSize="small" [nzScroll]="{ x: '850px' }">
                <thead>
                  <tr>
                    <th>{{ 'SIGN_ORDER.ADMIN.TIER_MIN' | translate }}</th>
                    <th>{{ 'SIGN_ORDER.ADMIN.TIER_MAX' | translate }}</th>
                    <th>{{ 'SIGN_ORDER.ADMIN.BASE_UNIT_PRICE' | translate }}</th>
                    <th>{{ 'SIGN_ORDER.ADMIN.DRILLING_UNIT_PRICE' | translate }}</th>
                    <th>{{ 'SIGN_ORDER.ADMIN.UNLIMITED' | translate }}</th>
                    <th>{{ 'SIGN_ORDER.ADMIN.ACTIONS' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let tier of pricingTiers.controls; index as i" [formGroupName]="i">
                    <td>
                      <nz-input-number formControlName="minQuantity" [nzMin]="1" [nzStep]="1" [nzPrecision]="0" nzSize="small"></nz-input-number>
                    </td>
                    <td>
                      <nz-input-number
                        formControlName="maxQuantity"
                        [nzMin]="1"
                        [nzStep]="1"
                        [nzPrecision]="0"
                        [nzDisabled]="tier.get('unlimited')?.value === true"
                        nzSize="small"
                      ></nz-input-number>
                    </td>
                    <td>
                      <nz-input-number formControlName="unitNetCents" [nzMin]="0" [nzStep]="1" [nzPrecision]="0" nzSize="small"></nz-input-number>
                    </td>
                    <td>
                      <nz-input-number formControlName="drillingUnitNetCents" [nzMin]="0" [nzStep]="1" [nzPrecision]="0" nzSize="small"></nz-input-number>
                    </td>
                    <td>
                      <nz-switch formControlName="unlimited" (nzCheckedChange)="setTierUnlimited(tier, $event)"></nz-switch>
                    </td>
                    <td>
                      <button
                        nz-button
                        nzDanger
                        nzSize="small"
                        type="button"
                        [attr.aria-label]="'SIGN_ORDER.ADMIN.REMOVE_TIER' | translate"
                        [nzTooltipTitle]="'SIGN_ORDER.ADMIN.REMOVE_TIER' | translate"
                        nz-tooltip
                        (click)="removeSignPricingTier(i)"
                      >
                        <i nz-icon nzType="delete"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </nz-table>
            </div>

            <nz-alert
              *ngIf="pricingTiers.touched && productTierValidationKey()"
              nzType="error"
              [nzMessage]="productTierValidationKey()! | translate"
              nzShowIcon
              class="tier-validation"
            ></nz-alert>

            <button
              nz-button
              nzType="dashed"
              type="button"
              [disabled]="!canAddSignPricingTier()"
              (click)="addSignPricingTier()"
            >
              <i nz-icon nzType="plus"></i>
              {{ 'SIGN_ORDER.ADMIN.ADD_TIER' | translate }}
            </button>
          </nz-card>

          <div class="form-actions">
            <button nz-button nzType="primary" type="button" [nzLoading]="savingProduct" (click)="saveProduct()">
              {{ 'SIGN_ORDER.ADMIN.SAVE' | translate }}
            </button>
          </div>
        </form>

        <nz-card [nzTitle]="'SIGN_ORDER.ADMIN.PRODUCT_IMAGES' | translate" *ngIf="product">
          <div class="image-upload-row">
            <nz-upload
              [nzAction]="uploadUrl"
              nzAccept="image/png,image/jpeg,image/webp"
              [nzHeaders]="{ Authorization: authToken }"
              (nzChange)="onImageUpload($event)"
              [nzShowUploadList]="false"
            >
              <button nz-button type="button"><i nz-icon nzType="upload"></i> {{ 'SIGN_ORDER.ADMIN.UPLOAD_IMAGE' | translate }}</button>
            </nz-upload>
          </div>
          <nz-table [nzData]="product.images" [nzShowPagination]="false" nzSize="small">
            <thead>
              <tr>
                <th style="width:72px"></th>
                <th>{{ 'SIGN_ORDER.ADMIN.IMAGE_ORDER' | translate }}</th>
                <th>{{ 'SIGN_ORDER.ADMIN.IMAGE_CAPTION_DE' | translate }}</th>
                <th>{{ 'SIGN_ORDER.ADMIN.ALT' | translate }} (DE)</th>
                <th>{{ 'SIGN_ORDER.ADMIN.IMAGE_CAPTION_EN' | translate }}</th>
                <th>{{ 'SIGN_ORDER.ADMIN.ALT' | translate }} (EN)</th>
                <th>{{ 'SIGN_ORDER.ADMIN.ACTIONS' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let img of product.images; index as i">
                <td>
                  <img
                    [src]="getImagePreviewUrl(i)"
                    class="product-thumb"
                    nz-tooltip
                    [nzTooltipTitle]="getImageTooltipTitle(img.assetKey, i)"
                    (click)="openPreview(getImagePreviewUrl(i))"
                    *ngIf="getImagePreviewUrl(i); else thumbPlaceholder"
                  />
                  <ng-template #thumbPlaceholder>
                    <i nz-icon nzType="picture" class="thumb-placeholder"></i>
                  </ng-template>
                </td>
                <td>{{ i + 1 }}</td>
                <td><input nz-input [(ngModel)]="img.caption.de" [ngModelOptions]="{ standalone: true }" style="width:100px" /></td>
                <td><input nz-input [(ngModel)]="img.alt.de" [ngModelOptions]="{ standalone: true }" placeholder="Alt (DE)" style="width:100px" /></td>
                <td><input nz-input [(ngModel)]="img.caption.en" [ngModelOptions]="{ standalone: true }" style="width:100px" /></td>
                <td><input nz-input [(ngModel)]="img.alt.en" [ngModelOptions]="{ standalone: true }" placeholder="Alt (EN)" style="width:100px" /></td>
                <td>
                  <button nz-button nzType="link" nzSize="small" type="button" (click)="saveImageMeta(i)"><i nz-icon nzType="save"></i></button>
                  <button nz-button nzType="link" nzSize="small" type="button" (click)="moveImageUp(i)" *ngIf="i > 0"><i nz-icon nzType="arrow-up"></i></button>
                  <button nz-button nzType="link" nzSize="small" type="button" (click)="moveImageDown(i)" *ngIf="i < product.images.length - 1"><i nz-icon nzType="arrow-down"></i></button>
                  <button nz-button nzType="link" nzSize="small" nzDanger type="button" (click)="deleteImage(i)"><i nz-icon nzType="delete"></i></button>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </nz-card>
      </nz-spin>
    </nz-tab>
  </nz-tabset>

  <nz-modal [nzVisible]="previewVisible" [nzFooter]="null" [nzBodyStyle]="{ padding: '8px', textAlign: 'center' }" (nzOnCancel)="closePreview()">
    <ng-container *nzModalContent>
      <img [src]="previewUrl" style="max-width:100%;max-height:80vh" />
    </ng-container>
  </nz-modal>
</div>
